import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiSkeleton(theme: Theme): Components['MuiSkeleton'] {
  return {
    defaultProps: {
      animation: 'wave',
    },
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.shades[300],
      },
    },
  };
}
